'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresOmalomaPayController = function () {
  function WinresOmalomaPayController($rootScope, $scope, omalomaService) {
    _classCallCheck(this, WinresOmalomaPayController);

    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.omalomaService = omalomaService;
    this.clear();
  }

  _createClass(WinresOmalomaPayController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      if (this.omalomaService.returnedFromPaymentService()) {
        this.confirmPayment();
        return; // Don't initialize anything else, since we'll redirect
        // or show an error message anyway.
      }

      this.$rootScope.$on('omaloma-refresh', function () {
        return _this.refresh();
      });
      this.$scope.$watch(function () {
        return _this.bookingNumber;
      }, function () {
        return _this.refresh();
      });
      this.refresh();

      this.$scope.$on('return-to-payment-tab', function () {
        return _this.returnToPaymentTab = true;
      });
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.$scope.login = this.omalomaService.isLoggedInAsCustomer();
      this.$scope.balance = null;
      this.$scope.passengers = null;
      this.$scope.firstDueDate = null;
      this.$scope.selectedAmount = null;
      this.$scope.loadingPaymentMethods = false;
      this.$scope.selectedPaymentMethod = null;
      this.$scope.conditionsAccepted = false;
      this.$scope.bookingConditionsURL = '#';
      this.$scope.bookingInProcess = false;
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      this.clear();
      if (!this.bookingNumber || !this.omalomaService.isLoggedInAsCustomer()) return;
      this.loadBalance();
      this.loadPassengers(); // Required to divide payment amount amoung them
      this.getBookingConditions(this.$rootScope.winresConnectionName);
    }
  }, {
    key: 'loadPassengers',
    value: function loadPassengers() {
      var _this2 = this;

      this.omalomaService.getPassengers(this.bookingNumber).then(function (passengers) {
        _this2.$scope.passengers = passengers;
      }, function (error) {
        console.error('[WOP] Failed to get passengers for', _this2.bookingNumber, ':', error);
      });
    }
  }, {
    key: 'loadBalance',
    value: function loadBalance() {
      var _this3 = this;

      this.omalomaService.getCustomerBookingBalance(this.bookingNumber).then(function (balance) {
        console.log('[WOP] Got balance for', _this3.bookingNumber, ':', balance);
        _this3.$scope.balance = balance;
        var byDueDate = _.sortBy(balance.ActiveInvoices, function (iv) {
          return iv.DueDate;
        });
        if (byDueDate.length > 0) {
          _this3.$scope.firstDueDate = byDueDate[0].DueDate;
        }

        // Booking invoices total price does not match with booking total price.
        // Prevent payment. 
        _this3.$scope.bookingInProcess = balance.Error === 'InvalidTotal';

        /*if(this.returnToPaymentTab){
            document.querySelector("[href*=tab-1493036671149-3-9]").parentNode.click();
        }*/
      }, function (error) {
        console.error('[WOP] Failed to get balance for', _this3.bookingNumber, ':', error);
      });
    }
  }, {
    key: 'selectAmount',
    value: function selectAmount(amount) {
      console.log('[WOP] Selected payment amount:', amount);
      this.$scope.selectedAmount = amount;
      this.loadPaymentMethods(amount);
    }
  }, {
    key: 'loadPaymentMethods',
    value: function loadPaymentMethods(amount) {
      var _this4 = this;

      this.$scope.paymentMethods = [];
      this.$scope.loadingPaymentMethods = true;

      return this.omalomaService.getCustomerPaymentMethods(this.bookingNumber, amount).then(function (methods) {
        console.log('[WOP] Got payment methods for', _this4.bookingNumber, '(amount', amount, '):', methods);
        _this4.$scope.paymentMethods = methods;
        _this4.$scope.loadingPaymentMethods = false;
        var selectedMethod = _this4.$scope.selectedPaymentMethod;
        var sameMethod = selectedMethod && _.find(methods, function (m) {
          return m.InternalName === selectedMethod.InternalName;
        });
        _this4.$scope.selectedPaymentMethod = sameMethod || null;
      }, function (error) {
        console.error('[WOP] Failed to get payment methods for', _this4.bookingNumber, ':', error);
        _this4.$scope.loadingPaymentMethods = false;
      });
    }
  }, {
    key: 'getBookingConditions',
    value: function getBookingConditions(connectionName) {
      var _this5 = this;

      if (!connectionName) {
        console.error("[WOP] error getting booking conditions. No connection name.");
      } else {
        console.log('[WOP] Getting site office parameters...  connection name is', connectionName);
        this.omalomaService.getOfficeSiteParameters(connectionName).then(function (params) {
          console.log("[WOP] Got Office parameters, response: ", params);
          _this5.$scope.bookingConditionsURL = params.Office.BookingConditionsFi;
        }).catch(function (error) {
          console.error('[WOP] Failed to get parameters:', error);
          if (error) {
            console.error("[WOP]  Connection Name not ok");
            _this5.setConnectionStatusFalse();
          }
        });
      }
    }
  }, {
    key: 'selectPaymentMethod',
    value: function selectPaymentMethod(method) {
      this.$scope.selectedPaymentMethod = method;
      console.log('[WOP] Selected payment method:', this.$scope.selectedPaymentMethod);
    }
  }, {
    key: 'pay',
    value: function pay() {
      console.log('[WOP] Paying.');

      var paymentSettings = {
        internalName: this.$scope.selectedPaymentMethod.InternalName,
        // okUrl: this.okUrl || ('' + window.location),
        // cancelUrl: this.cancelUrl || this.rejectUrl,
        // rejectUrl: this.rejectUrl || this.cancelUrl,
        okUrl: '' + window.location + encodeURI('&msg=paymentok'),
        cancelUrl: '' + window.location + encodeURI('&msg=paymentcancel'),
        rejectUrl: '' + window.location + encodeURI('&msg=paymentreject'),
        amountToPay: this.$scope.selectedAmount
      };

      // if (!paymentSettings.cancelUrl) {
      //   // Neither is defined
      //   paymentSettings.cancelUrl = paymentSettings.okUrl;
      //   paymentSettings.rejectUrl = paymentSettings.okUrl;
      // }

      this.omalomaService.payCustomerBooking(this.bookingNumber, paymentSettings).then(function (result) {
        // The service handles redirecting to payment processor
      }, function (error) {
        console.error('[WOP] Failed to pay:', error);
      });
    }
  }, {
    key: 'confirmPayment',
    value: function confirmPayment() {
      var paymentID = this.omalomaService.paymentID();
      console.log('[WOP] Returned from payment service. Confirming payment:', paymentID);

      // Should set a loading flag here to tell the user we're doing something.

      this.omalomaService.confirmPayment().then(function (result) {
        // Do nothing. We're getting redirected by the service anyway.
        // Could possibly set a flag to show a message in case it fails.
      }, function (error) {
        console.error('[OS] Failed to confirm payment', paymentID, ':', error);
        // Should set an error flag and show an error message here.
      });
    }
  }]);

  return WinresOmalomaPayController;
}();

WinresOmalomaPayController.$inject = ['$rootScope', '$scope', 'omalomaService'];

_module3.default.component('winresOmalomaPay', {
  template: require('./winresOmalomaPay.html'),
  controller: WinresOmalomaPayController,
  bindings: {
    bookingNumber: '<',

    // Where to redirect when returned from payment processor
    // NOT USED CURRENTLY
    // Parameters are overridden in code above.
    // NOT USED CURRENTLY
    okUrl: "@",
    cancelUrl: "@",
    rejectUrl: "@"
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresOmalomaPay/winresOmalomaPay.js
// module id = 349
// module chunks = 2